import { request as apiRequest } from './api'

const API_ENDPOINT = process.env.REACT_APP_COMPANY_API_ENDPOINT

const request = async (method, endpoint, data = undefined) =>
  apiRequest(method, endpoint, data, {}, API_ENDPOINT)

export const reorderLostCard = formValues =>
  request('POST', '/lost_card_orders', formValues)
